jQuery( $ => {
	const { routeUrl } = window.QalaB2bWholesale.listShippingMethodsRouteObj;
	const wpnonce = window.QalaB2bWholesale.listShippingMethodsRouteObj._wpnonce;

	/**
	 * Toggle the shipping address section.
	 *
	 * If show is true, it will show the shipping address section and slide it down if the checkbox is checked.
	 * If show is false, it will hide the shipping address section and uncheck the checkbox.
	 *
	 * @param {boolean} show - Whether to show the shipping address section.
	 */
	function showDifferentShippingAddress( show ) {
		const heading = $( '#ship-to-different-address' );
		const checkbox = $( '#ship-to-different-address-checkbox' );
		const shippingAddressSection = $( 'div.shipping_address' );

		if ( show ) {
			heading.show();
			if ( checkbox.is( ':checked' ) ) {
				shippingAddressSection.slideDown();
			}
		} else {
			checkbox.prop( 'checked', false );
			heading.hide();
			shippingAddressSection.hide();
		}
	}

	/**
	 * When the shipping address checkbox is checked, show the shipping address section.
	 */
	$( document.body ).on( 'updated_checkout', function() {
		const $selectedShippingMethod = $( 'input.shipping_method:checked' );

		if ( $selectedShippingMethod.length > 0 ) {
			const selectedShipingMethodKey = $selectedShippingMethod.val();

			$.get( {
				url: routeUrl,
				data: {
					_wpnonce: wpnonce,
				},
				success( responseData ) {
					if ( responseData.data && responseData.data.shipping_methods && responseData.data.shipping_methods.length > 0 ) {
						const selectedMethod = responseData.data.shipping_methods.find( shippingMethod => `${ shippingMethod.id }:${ shippingMethod.instance_id }` === selectedShipingMethodKey );

						const isAddressEditable = selectedMethod ? selectedMethod.is_address_editable : false;
						showDifferentShippingAddress( isAddressEditable );
					}
				},
			} );
		}
	} );
} );
